import React, { useState } from 'react';
import { useApi } from 'model/Api';
import { mediaQurey } from 'helper/Style';
import Layout from 'component/part/Layout';
import BackLink from 'component/part/BackLink';
import H2 from 'component/part/H2';
import { useEffect } from 'react';

const style = {
  codeArea: {
    [mediaQurey('min', 'tablet')]: {
      display: 'flex',
      justifyContent: 'center',
      img: {
        width: '40%',
        maxWidth: '50rem',
      },
    },
    [mediaQurey('max', 'sp')]: {
      img: {
        width: '100%',
      },
    },
  },
};

const LineRelationCode: React.FC = () => {
  const api = useApi();
  const [codeImageUrl, setCodeImageUrl] = useState('');

  useEffect(() => {
    (async () => {
      const lineCodeImageUrlResponse = await api.client.getLineCodeImageUrl();
      setCodeImageUrl(lineCodeImageUrlResponse || '');
    })();
  }, []);

  return <Layout>
    <BackLink link='/' label='トップ'></BackLink>
    <H2>LINEコード</H2>
    <div css={style.codeArea}>
      <img src={codeImageUrl} />
    </div>
  </Layout>;
};

export default LineRelationCode;
